import { MessageSquare, UserMinus, UserPlus } from 'lucide-react'
import { Message } from '../types/chat'
import React from 'react'

function ChatEvents({ message }: { message: Message }) {
    return (
        <div key={message.recordId} className="flex justify-center items-center my-3">
            <div className="px-3 py-1.5 rounded-full bg-muted/50 text-muted-foreground text-xs max-w-[90%] text-center flex items-center gap-1.5 justify-center font-medium">
                {message.role === 'add-participant' ? <UserPlus className="w-3 h-3" /> : message.role === 'conversation-title-updated' ? <MessageSquare className="w-3 h-3" /> : <UserMinus className="w-3 h-3" />}
                {message.generations[message.activeGenerationIndex ?? 0]?.content || message.generations[0]?.content}
            </div>
        </div>
    )
}

export default ChatEvents